import { apiSlice } from "../../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    OtpPassword: builder.mutation({
      query: ({ newpassword, otp }) => ({
        url: "forgotPassword/change",
        method: "POST",
        body: { newpassword }, 
        params: { otp }, 
      }),
    }),
  }),
});

export const { useOtpPasswordMutation } = sqlApiSlice;
